// components/scheduler/SchedulerStatusCard.tsx
import React from 'react';
import { Card, Statistic, Button, Spin } from 'antd';
import { SyncOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useGetSchedulerStatus } from '@/shared/api/client/reminder-configuration-controller';
import { SchedulerStatus } from '../../types/notification';

interface SchedulerStatusCardProps {
    onRefresh: () => void;
}

const SchedulerStatusCard: React.FC<SchedulerStatusCardProps> = ({
                                                                     onRefresh
                                                                 }) => {
    const { data: statusData, isLoading, refetch } = useGetSchedulerStatus();
    // @ts-ignore
    const status: SchedulerStatus | undefined = statusData?.data as SchedulerStatus;

    const handleRefresh = () => {
        refetch();
        onRefresh();
    };

    return (
        <Card className="mb-4">
            <div className="flex justify-between items-center">
                <div className="flex items-center space-x-8">
                    <Statistic
                        title="Active Scheduled Tasks"
                        value={status?.activeTaskCount || 0}
                        loading={isLoading}
                        prefix={<ClockCircleOutlined />}
                    />

                    {status?.lastRefreshTime && !isLoading && (
                        <div className="text-sm text-gray-500">
                            Last refresh: {new Date(status.lastRefreshTime).toLocaleString()}
                        </div>
                    )}
                </div>

                <Button
                    icon={<SyncOutlined />}
                    onClick={handleRefresh}
                    loading={isLoading}
                >
                    Refresh
                </Button>
            </div>
        </Card>
    );
};

export default SchedulerStatusCard;